/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3ImagesTransactionsTransactionHashPngRequest = {
  transactionHash: string;
};

/** @internal */
export const GetApiV3ImagesTransactionsTransactionHashPngRequest$inboundSchema:
  z.ZodType<
    GetApiV3ImagesTransactionsTransactionHashPngRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    transaction_hash: z.string(),
  }).transform((v) => {
    return remap$(v, {
      "transaction_hash": "transactionHash",
    });
  });

/** @internal */
export type GetApiV3ImagesTransactionsTransactionHashPngRequest$Outbound = {
  transaction_hash: string;
};

/** @internal */
export const GetApiV3ImagesTransactionsTransactionHashPngRequest$outboundSchema:
  z.ZodType<
    GetApiV3ImagesTransactionsTransactionHashPngRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3ImagesTransactionsTransactionHashPngRequest
  > = z.object({
    transactionHash: z.string(),
  }).transform((v) => {
    return remap$(v, {
      transactionHash: "transaction_hash",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3ImagesTransactionsTransactionHashPngRequest$ {
  /** @deprecated use `GetApiV3ImagesTransactionsTransactionHashPngRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3ImagesTransactionsTransactionHashPngRequest$inboundSchema;
  /** @deprecated use `GetApiV3ImagesTransactionsTransactionHashPngRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3ImagesTransactionsTransactionHashPngRequest$outboundSchema;
  /** @deprecated use `GetApiV3ImagesTransactionsTransactionHashPngRequest$Outbound` instead. */
  export type Outbound =
    GetApiV3ImagesTransactionsTransactionHashPngRequest$Outbound;
}

export function getApiV3ImagesTransactionsTransactionHashPngRequestToJSON(
  getApiV3ImagesTransactionsTransactionHashPngRequest:
    GetApiV3ImagesTransactionsTransactionHashPngRequest,
): string {
  return JSON.stringify(
    GetApiV3ImagesTransactionsTransactionHashPngRequest$outboundSchema.parse(
      getApiV3ImagesTransactionsTransactionHashPngRequest,
    ),
  );
}

export function getApiV3ImagesTransactionsTransactionHashPngRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3ImagesTransactionsTransactionHashPngRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3ImagesTransactionsTransactionHashPngRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3ImagesTransactionsTransactionHashPngRequest' from JSON`,
  );
}
